(function () {
  var CONTAINER_SEL = '[data-product-media-container]';
  var ITEM_SEL = '[data-variant-id]';
  var DEBUG = typeof window !== 'undefined' && window.VARIANT_GALLERY_DEBUG === true;
  var LOG = function () {};
  var LOG_DEBUG = function () {};

  function getVariantId() {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('variant');
    if (fromUrl) return fromUrl;
    var form = document.querySelector('.product form[action*="/cart/add"]');
    if (form) {
      var input = form.querySelector('input[name="id"]') || form.querySelector('input[data-product-form-variant]');
      if (input && input.value) return input.value.trim();
    }
    return null;
  }

  var HIDE_STYLES = [
    'visibility', 'width', 'height', 'min-width', 'min-height',
    'max-width', 'max-height', 'overflow', 'margin', 'padding', 'flex', 'display'
  ];

  var displayNoneTimeoutId = null;
  var DISPLAY_NONE_DELAY_MS = 1500;

  function isMobileMediaContainer(container) {
    return container && container.classList && container.classList.contains('product-mobile-media');
  }

  function applyVisibility(variantId) {
    LOG('applyVisibility called variantId=' + variantId);
    if (!variantId) return;
    if (displayNoneTimeoutId) {
      clearTimeout(displayNoneTimeoutId);
      displayNoneTimeoutId = null;
    }
    var id = String(variantId);
    var totalMatch = 0;
    var totalHide = 0;
    document.querySelectorAll('.product').forEach(function (product) {
      product.querySelectorAll(CONTAINER_SEL).forEach(function (container) {
        if (isMobileMediaContainer(container)) return;
        container.querySelectorAll(ITEM_SEL).forEach(function (el) {
          var match = el.getAttribute('data-variant-id') === id;
          if (match) {
            totalMatch++;
            HIDE_STYLES.forEach(function (prop) {
              el.style.removeProperty(prop);
            });
          } else {
            totalHide++;
            el.style.setProperty('visibility', 'hidden');
            el.style.setProperty('width', '0');
            el.style.setProperty('height', '0');
            el.style.setProperty('min-width', '0');
            el.style.setProperty('min-height', '0');
            el.style.setProperty('max-width', '0');
            el.style.setProperty('max-height', '0');
            el.style.setProperty('overflow', 'hidden');
            el.style.setProperty('margin', '0');
            el.style.setProperty('padding', '0');
            el.style.setProperty('flex', '0 0 0');
          }
        });
      });
    });
    LOG('applyVisibility done visible=' + totalMatch + ' hidden=' + totalHide + ' scheduling scroll+reinit');
    [0, 400, 800, 1200, 2000].forEach(function (delay) {
      setTimeout(function () {
        LOG('scrollCarouselsToFirstVisibleSlide (' + delay + 'ms) variantId=' + id);
        scrollCarouselsToFirstVisibleSlide(id);
      }, delay);
    });
    displayNoneTimeoutId = setTimeout(function () {
      LOG('displayNone timeout fired (' + DISPLAY_NONE_DELAY_MS + 'ms) applying display:none');
      displayNoneTimeoutId = null;
      var currentId = String(getVariantId() || '');
      document.querySelectorAll('.product').forEach(function (product) {
        product.querySelectorAll(CONTAINER_SEL).forEach(function (container) {
          if (isMobileMediaContainer(container)) return;
          container.querySelectorAll(ITEM_SEL).forEach(function (el) {
            if (el.getAttribute('data-variant-id') !== currentId) {
              el.style.setProperty('display', 'none');
            }
          });
        });
      });
      setTimeout(function () {
        LOG('scrollCarouselsToFirstVisibleSlide (after displayNone 0ms)');
        scrollCarouselsToFirstVisibleSlide(currentId);
      }, 0);
      setTimeout(function () {
        LOG('scrollCarouselsToFirstVisibleSlide (after displayNone 100ms)');
        scrollCarouselsToFirstVisibleSlide(currentId);
      }, 100);
    }, DISPLAY_NONE_DELAY_MS);
  }

  function isVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  function scrollViewportToSlide(viewport, container, targetSlide) {
    if (!viewport || !targetSlide) return false;
    var axis = 'x';
    var carousel = viewport.closest && viewport.closest('carousel-component');
    if (carousel && carousel.getAttribute('data-axis') === 'y') axis = 'y';

    if (container && container !== viewport && container.parentNode === viewport) {
      var pos = axis === 'y' ? targetSlide.offsetTop : targetSlide.offsetLeft;
      var tx = axis === 'y' ? 0 : -pos;
      var ty = axis === 'y' ? -pos : 0;
      container.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0px)';
      return true;
    }

    var overflow = window.getComputedStyle(viewport).overflow;
    var canScroll = overflow === 'auto' || overflow === 'scroll' || overflow === 'overlay';
    if (canScroll) {
      if (axis === 'x') {
        var left = targetSlide.offsetLeft;
        if (container && container !== viewport) left += container.offsetLeft || 0;
        viewport.scrollLeft = left;
        return true;
      }
      viewport.scrollTop = targetSlide.offsetTop + (container ? (container.offsetTop || 0) : 0);
      return true;
    }
    try {
      targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      return true;
    } catch (err) {
      return false;
    }
  }

  function reinitCarousel(viewport) {
    if (!viewport) return false;
    var carousel = viewport.closest && viewport.closest('carousel-component');
    if (carousel && typeof carousel.reInit === 'function') {
      LOG('reinitCarousel: calling carousel.reInit()');
      carousel.reInit();
      return true;
    }
    if (viewport.emblaApi && typeof viewport.emblaApi.reInit === 'function') {
      LOG('reinitCarousel: calling viewport.emblaApi.reInit()');
      viewport.emblaApi.reInit();
      return true;
    }
    LOG('reinitCarousel: no reInit (carousel.reInit=' + !!(carousel && typeof carousel.reInit === 'function') + ' emblaApi=' + !!viewport.emblaApi + ')');
    return false;
  }

  function scrollCarouselsToFirstVisibleSlide(variantId) {
    if (!variantId) {
      LOG('scrollCarouselsToFirstVisibleSlide skipped: no variantId');
      return;
    }
    var id = String(variantId);
    var containers = document.querySelectorAll('.product ' + CONTAINER_SEL);
    LOG('scrollCarouselsToFirstVisibleSlide containers=' + containers.length + ' variantId=' + id);
    containers.forEach(function (container, ci) {
      var isMobile = container.classList && container.classList.contains('product-mobile-media');
      if (isMobile) {
        return;
      }
      var mainViewport = container.querySelector('carousel-component [data-carousel-viewport]');
      var mainContainer = mainViewport && mainViewport.querySelector('[data-carousel-container]');
      if (!mainViewport || !mainContainer) {
        LOG('  container[' + ci + '] no viewport or mainContainer');
        return;
      }
      var allSlides = mainContainer.children.length;
      var slides = Array.prototype.filter.call(mainContainer.children, function (el) {
        return el.getAttribute('data-variant-id') === id && isVisible(el);
      });
      var first = slides[0];
      LOG('  container[' + ci + '] totalSlides=' + allSlides + ' visibleForVariant=' + slides.length + ' first=' + (first ? 'yes' : 'no'));
      if (!first) {
        LOG('  container[' + ci + '] no visible slide for variant - skip scroll');
        return;
      }
      var didScroll = scrollViewportToSlide(mainViewport, mainContainer, first);
      var didReinit = reinitCarousel(mainViewport);
      if (didReinit) {
        var scrollAgain = function () {
          scrollViewportToSlide(mainViewport, mainContainer, first);
        };
        setTimeout(scrollAgain, 0);
        setTimeout(scrollAgain, 50);
        setTimeout(scrollAgain, 150);
      }
      LOG('  container[' + ci + '] scroll=' + didScroll + ' reinit=' + didReinit);
    });
  }

  var THUMB_CLICKS_SETUP = 'data-variant-gallery-thumb-clicks';
  var SETUP_DELAYS_MS = [0, 100, 300, 800, 2000];

  function setupVariantGalleryThumbClicks() {
    var containers = document.querySelectorAll('.product ' + CONTAINER_SEL);
    LOG('setupVariantGalleryThumbClicks run, product containers: ' + containers.length);

    containers.forEach(function (container, ci) {
      if (container.getAttribute(THUMB_CLICKS_SETUP) === '1') {
        LOG('container ' + ci + ' already has thumb clicks');
        return;
      }

      var dotsContainer = container.querySelector('carousel-dots [data-carousel-container]');
      var mainViewport = container.querySelector('carousel-component [data-carousel-viewport]');
      LOG('container ' + ci + ' dotsContainer=' + !!dotsContainer + ' mainViewport=' + !!mainViewport);

      if (!dotsContainer || !mainViewport) return;

      var mainContainer = mainViewport.querySelector('[data-carousel-container]');
      if (!mainContainer) {
        LOG('container ' + ci + ' no mainContainer');
        return;
      }

      container.setAttribute(THUMB_CLICKS_SETUP, '1');
      LOG('container ' + ci + ' thumb click listener attached');

      dotsContainer.addEventListener('click', function (e) {
        LOG('click on dotsContainer, target=' + (e.target ? e.target.nodeName + '.' + (e.target.className || '').split(' ')[0] : '?'));
        var dot = e.target.closest('[data-carousel-dot][data-variant-id]');
        if (!dot) dot = e.target.closest('[data-carousel-dot]');
        LOG('thumb area clicked, dot=' + !!dot + ' dotVariantId=' + (dot ? dot.getAttribute('data-variant-id') : 'n/a'));

        if (!dot) {
          LOG('skip: no dot found');
          return;
        }

        var variantId = String(getVariantId() || '');
        var dotVariantId = dot.getAttribute('data-variant-id');
        LOG('variantId=' + variantId + ' dotVariantId=' + dotVariantId);

        if (!variantId || dotVariantId !== variantId) {
          LOG('skip: variant mismatch or no variantId');
          return;
        }

        var thumbs = Array.prototype.filter.call(dotsContainer.children, function (el) {
          return el.getAttribute('data-variant-id') === variantId && isVisible(el);
        });
        var visibleIndex = thumbs.indexOf(dot);
        LOG('visible thumbs=' + thumbs.length + ' visibleIndex=' + visibleIndex);

        if (visibleIndex < 0) {
          LOG('skip: visibleIndex < 0');
          return;
        }

        var slides = Array.prototype.filter.call(mainContainer.children, function (el) {
          return el.getAttribute('data-variant-id') === variantId && isVisible(el);
        });
        var targetSlide = slides[visibleIndex];
        LOG('visible slides=' + slides.length + ' targetSlide=' + !!targetSlide);

        if (!targetSlide) {
          LOG('skip: no targetSlide');
          return;
        }

        var domIndex = Array.prototype.indexOf.call(mainContainer.children, targetSlide);
        LOG('domIndex=' + domIndex);

        var didScroll = scrollViewportToSlide(mainViewport, mainContainer, targetSlide);

        if (didScroll) {
          e.preventDefault();
          e.stopPropagation();
          thumbs.forEach(function (thumb, i) {
            thumb.classList.toggle('is-primary', i === visibleIndex);
          });
          LOG('scroll to index ' + domIndex + ' done');
        } else {
          LOG('skip: scrollViewportToSlide failed');
        }
      }, true);
    });
  }

  function init() {
    var vid = getVariantId();
    LOG('init variantId=' + vid + ' readyState=' + document.readyState);
    applyVisibility(vid);

    SETUP_DELAYS_MS.forEach(function (delay) {
      setTimeout(setupVariantGalleryThumbClicks, delay);
    });

    var lastId = getVariantId();
    setInterval(function () {
      var current = getVariantId();
      if (current !== lastId) {
        LOG('variant change detected ' + lastId + ' -> ' + current);
        lastId = current;
        applyVisibility(current);
      }
    }, 400);
  }

  LOG('product-variant-logger.js loaded');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
